export const initialState = {
  isLoadingNameValidation: false,
};

export function CLUSTER_GROUP_NAME_VALIDATION_REQUEST(nextState) {
  nextState.isLoadingNameValidation = true;
}

export function CLUSTER_GROUP_NAME_VALIDATION_SUCCESS(nextState) {
  nextState.isLoadingNameValidation = false;
}

export function CLUSTER_GROUP_NAME_VALIDATION_FAILURE(nextState) {
  nextState.isLoadingNameValidation = false;
}
